module.exports = __webpack_public_path__ + "static/media/text-image.db47f97f.png";